$(document).ready(function(){
  $('.searchpopup').click(function(){
  	$('.search-popup').show();
  });
  $('.closebn').click(function(){
  	$('.search-popup').hide();
  });
  var btn = $('#button');
  btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });
});
                                                                                                                                                             
$('.section-block-header').click(function() {
  var submenu = $(this).siblings('.nav-side');
  if($(this).hasClass('active')){
    $(this).removeClass('active');
     $(submenu).slideUp(100);
  } else {
    $(this).addClass('active'); 
     $(submenu).slideDown(100);
  }
});
                                                                                                                                                                                                                                                                          
                                                                                                                                                                                                                                            